import React from "react";

import { cn } from "../../helpers";
import { separatorVariants } from "./separator.styled";

type SeparatorProps = {
  orientation?: "horizontal" | "vertical";
  variant?: "solid" | "dashed";
  className?: string;
};

export const Separator = ({
  orientation = "horizontal",
  variant = "solid",
  className,
}: SeparatorProps) => {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn(separatorVariants({ orientation, variant }), className)}
    />
  );
};
